import apiClient from '../helpers/apiClient';

class UserService {
    registerUser = (data, props) => apiClient().post('registration', data);
    loginUser = (credentials, props) => apiClient().post('login', credentials);
    logoutUser = () => apiClient().get('logout');
    loadUserProfile = () => apiClient().post('view_profile');
}

export default new UserService();